import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import {
  addPlacedPolygon,
  resetPlacement,
  setIsPolygonPlacementMode,
  removePlacedPolygon,
  setEditingPolygonId,
} from "../../redux/polygonPlacement";
import { setPVDesignRequestBoxOpen } from "../../redux/pvDesign";

const PolygonPlacementControls = () => {
  const dispatch = useDispatch();
  const { newPolygon, isPlacementMode, editingPolygonId, isPlaced } =
    useSelector((state) => state.polygonPlacement);
  const { isPVDesignActive } = useSelector((state) => state.pvDesign);

  const handleResetClick = () => {
    dispatch(resetPlacement());
  };

  const handleSubmitClick = () => {
    if (newPolygon) {
      const newObject = {
        id: Date.now(),
        ...newPolygon,
      };
      dispatch(addPlacedPolygon(newObject));
      dispatch(resetPlacement());
    }
  };
  const handleExit = () => {
    dispatch(resetPlacement());
    dispatch(setIsPolygonPlacementMode(false));
    dispatch(setPVDesignRequestBoxOpen(true));
  };

  const handleDeleteClick = () => {
    dispatch(removePlacedPolygon(editingPolygonId));
    dispatch(setEditingPolygonId(null));
  };

  return (
    <>
      {isPlacementMode && isPVDesignActive && (
        <div className="execution-cta-container">
          {newPolygon?.verts?.length && (
            <Button variant="secondary" onClick={handleResetClick}>
              Reset
            </Button>
          )}

          {isPlaced && (
            <Button variant="success" onClick={handleSubmitClick}>
              Submit
            </Button>
          )}
          <Button variant="danger" onClick={handleExit}>
            Exit
          </Button>
        </div>
      )}
      {editingPolygonId && (
        <div className="execution-cta-container">
          <Button variant="danger" onClick={handleDeleteClick}>
            Delete
          </Button>
        </div>
      )}
    </>
  );
};

export default PolygonPlacementControls;
